import { FormBuilder, Validators } from '@angular/forms';
import { Examen } from '../Examen.config';
import { apellidoNombreTrabajadorValidator } from '../../../../../utils/apellido-nombre-trabajador-validator';

export class EstudioAumentoPresionVenosa extends Examen {
  id = 110;
  code = 'VMMII';
  name = 'CUESTIONARIO DIRECCIONADO AUMENTO PRESIÓN VENOSA MMII';
  baseUrl = 'estudios/carga';
  isAttachedFileRequire = false;
  sections = [
    {
      name: 'CUESTIONARIO DIRECCIONADO AUMENTO PRESIÓN VENOSA MMII',
      fields: {
        fechaRealizacion: [ '', [ Validators.required ] ],
      },
    },
    {
      name: 'Empleador',
      fields: {},
      numberForm: 1,
    },
    {
      name: 'Trabajador',
      fields: {
        apellidoNombre:['', [Validators.required, Validators.maxLength(100), apellidoNombreTrabajadorValidator]],
        fechaNacimiento: ['', [Validators.required]],    
        puestoTrabajador: ['', [Validators.required]],
        fechaIngresoEmpresa: ['', [Validators.required]],
        antiguedadPuestoTrabajador: ['', [Validators.required]],
      },
      numberForm: 2,
    },
    {
      name: 'Antecedentes Laborales',
      fields: {
        tarea: ['', [Validators.required, Validators.maxLength(250)]],
        tiempoTarea: ['', [Validators.required, Validators.maxLength(250)]],
        bipedestacionEstatica: [false],
        bipedestacionRestringida: [false],
        bipedestacionCarga: [false],
        bipedestacionExposicion: [false],
        sintomasPrevio2014: [false],
        bipedestacionNingunaAnteriores: [true],
        sintomasRefiere: ['', [Validators.required, Validators.maxLength(250)]],
      },
      numberForm: 3,
    },
    {
      name: 'Antecedentes Personales',
      fields: {
        peso: [null, [Validators.required, Validators.min(40), Validators.max(180)]],
        talla: [null, [Validators.required, Validators.min(100), Validators.max(220)]],
        indiceMasaCorporal: [null, [Validators.required]],
        noFumador: [true],
        fumador: [false],
        exFumador: [false],
        fumaUnoDiez: [{ value: false, disabled: true }],
        fumaOnceVeinte: [{ value: false, disabled: true }],
        fumaMasVeinte: [{ value: false, disabled: true }],
        cantidadTiempoFumando: [{ value: null, disabled: true }],
        unidadTiempoFumando: [{ value: '', disabled: true }],
        afeccionesCardiovasculares: [false, [Validators.required]],
        afeccionesCardiovascularesDescripcion: [{ value: '', disabled: true }],
        afeccionesMetabolicas: [false, [Validators.required]],
        afeccionesMetabolicasDescripcion: [{ value: '', disabled: true }],
        anticonceptivosOrales: [false, [Validators.required]],
        embarazos: [false, [Validators.required]],
        antecedentesFamiliaresVaricopatia: ['', [Validators.required, Validators.maxLength(250)]],
        tratamientoMedicoActual: ['', [ Validators.maxLength(250)]],
      },
      numberForm: 4,
    },
    {
      name: 'Examen Clínico',
      fields: {
        antecedentesVarices: [false, [Validators.required]],
        antecedentesVaricesOperada: [{ value: false, disabled: true }],
        antecedentesVaricesAnio: [{ value: '', disabled: true }],
        varicocele: [false, [Validators.required]],
        varicoceleOperada: [{ value: false, disabled: true }],
        varicoceleAnio: [{ value: '', disabled: true }],
        hemorroides: [false, [Validators.required]],
        hemorroidesOperada: [{ value: false, disabled: true }],
        hemorroidesAnio: [{ value: '', disabled: true }],
        c0mizq: [false],
        c0mder: [false],
        c0bilateral: [false],
        c0asintomatico: [false],
        c0sintomatico: [false],
        c1mizq: [false],
        c1mder: [false],
        c1bilateral: [false],
        c1asintomatico: [false],
        c1sintomatico: [false],
        c2mizq: [false],
        c2mder: [false],
        c2bilateral: [false],
        c2asintomatico: [false],
        c2sintomatico: [false],
        c3mizq: [false],
        c3mder: [false],
        c3bilateral: [false],
        c3asintomatico: [false],
        c3sintomatico: [false],
        c4amizq: [false],
        c4amder: [false],
        c4abilateral: [false],
        c4aasintomatico: [false],
        c4asintomatico: [false],
        c4bmizq: [false],
        c4bmder: [false],
        c4bbilateral: [false],
        c4basintomatico: [false],
        c4bsintomatico: [false],
        c5mizq: [false],
        c5mder: [false],
        c5bilateral: [false],
        c5asintomatico: [false],
        c5sintomatico: [false],
        c6mizq: [false],
        c6mder: [false],
        c6bilateral: [false],
        c6asintomatico: [false],
        c6sintomatico: [false],
      },
      numberForm: 5,
    },
    {
      name: 'Dictamen medico',
      fields: {
        medicoNombre: [ '', [ Validators.required, Validators.pattern( /^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ\s]+$/ ), ] ],
        codigoDictamen: [ '', [ Validators.required ] ],
        matricula: ['', [Validators.required]],
        medicoEspecialidad: ['', [Validators.required]],
      },
      numberForm: 6,
    },
    {
      name: 'Adjuntos',
      fields: {},
      numberForm: 7,
    },
  ];

  constructor( formBuilder: FormBuilder ) {
    super( formBuilder );
    this.fieldList = this.getFields();
    this.examForm = this.getForm();
    this.sectionsList = this.getSections();
  }
}
